import { CardMedia, IconButton } from "@mui/material";
import React from "react";
import { handleDownload } from "../store/one-query/useMethodHelper";

interface DownloadImageProps {
  style: {};
  imgURL: string | undefined;
}

export const DownloadImage = ({ style, imgURL }: DownloadImageProps) => {
  const handleDownloadGeneratedImage = () => {
    if (imgURL) {
      handleDownload(imgURL);
    }
  };
  return (
    <IconButton
      sx={style}
      onClick={handleDownloadGeneratedImage}
    >
      <CardMedia
          component={"img"}
          image="/Images/VideoSuite/downloadIcon.svg"
          className="icon-download-image general-download-icon"
      />
    </IconButton>
  );
};
